import { render, staticRenderFns } from "./DynamicComponent.vue?vue&type=template&id=6ab1c238&"
import script from "./DynamicComponent.vue?vue&type=script&lang=js&"
export * from "./DynamicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports